.role-list,
.user-list {
  font-size: 0.875rem;
}
.role-list__empty,
.user-list__empty {
  padding: 2rem;
  text-align: center;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.role-caret-cell,
.user-caret-cell {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #666666;
}
.role-caret-cell:hover,
.user-caret-cell:hover {
  color: rgb(10%, 10%, 10%);
}

.role-row-wrapper,
.user-row-wrapper {
  cursor: pointer;
}

.role-list .list-item--header .actions--header .list-item--header__col,
.user-list .list-item--header .actions--header .list-item--header__col {
  font-size: 0;
}
.role-list .list-item--header .actions--header .list-item--header__col::after,
.user-list .list-item--header .actions--header .list-item--header__col::after {
  content: "Actions";
  font-size: 0.875rem;
}

.role-list .list-item__col:first-child,
.user-list .list-item__col:first-child {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
}

.role-list .dropdown-menu,
.user-list .dropdown-menu {
  min-width: 12rem;
}

.delivery-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 400;
  background-color: rgb(90%, 90%, 90%);
  color: rgb(25%, 25%, 25%);
}
.delivery-tag--none {
  background: none;
  color: #666666;
  font-weight: 400;
  padding: 0;
}

.role-row__conditions-label,
.user-row__conditions-label {
  font-size: 0.8rem;
  color: #666666;
  font-weight: 600;
  text-align: left;
}

.role-expansion-wrapper,
.user-expansion-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.2s ease-out;
}
.role-expansion-wrapper > div,
.user-expansion-wrapper > div {
  overflow: hidden;
}
.role-expansion-wrapper--open,
.user-expansion-wrapper--open {
  grid-template-rows: 1fr;
}

.user-expansion {
  font-size: 0.875rem;
}
.user-expansion__row {
  display: flex;
  align-items: stretch;
  min-height: 2.2rem;
}
.user-expansion__spacer {
  flex-shrink: 0;
}
.user-expansion__col-onoff {
  display: flex;
  align-items: center;
  margin-right: 0.2rem;
  box-sizing: border-box;
  flex-shrink: 0;
}
.user-expansion__col-conditions {
  display: flex;
  align-items: center;
  margin-right: 0.2rem;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 18rem;
  padding: 0.3rem 1.2rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
}
.user-expansion__col-delivery {
  display: flex;
  align-items: center;
  margin-right: 0.2rem;
  box-sizing: border-box;
  flex: 1;
  min-width: 0;
  padding: 0.3rem 1.2rem;
  gap: 0.4rem;
  flex-wrap: wrap;
}
.user-expansion__col-options {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0;
  margin-right: 0;
}
.user-expansion__onoff {
  justify-content: center;
  font-weight: 700;
  font-size: 0.75rem;
  padding: 0 1.2rem;
}
.user-expansion__onoff span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.6rem;
  border-radius: 0.25rem;
  min-width: 2.5rem;
}
.user-expansion__onoff--on span {
  background-color: #d7e6cf;
  color: #414141;
  font-weight: 400;
}
.user-expansion__onoff--off span {
  background-color: #e8e8e8;
  color: #414141;
  font-weight: 400;
}
.user-expansion__conditions {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}
.user-expansion__state {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.user-expansion__delivery {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.3rem;
}
.user-expansion__col-caret, .user-expansion__col-user, .user-expansion__col-role, .user-expansion__col-onoff {
  display: flex;
  align-items: center;
  margin-right: 0.2rem;
  box-sizing: border-box;
  flex-shrink: 0;
}
.user-expansion__col-caret {
  width: 4rem;
  justify-content: center;
}
.user-expansion__col-user {
  width: 18rem;
}
.user-expansion__col-role {
  width: 14rem;
}
.user-expansion__col-onoff {
  width: 6rem;
}
.user-expansion__col-options {
  width: 7rem;
}

.user-name-content {
  display: flex;
  align-items: center;
  width: 100%;
}
.user-name-content__email {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
  width: 100%;
}
.user-role-content > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
}
.user-role-content .type-label-component {
  text-transform: none;
  background-color: #e6e6e6;
  color: #414141;
  flex-shrink: 0;
  margin-left: auto;
}

.light-theme {
  --zebra-odd: #ffffff;
  --zebra-even: rgb(95%, 95%, 95%);
}
.light-theme .user-row--odd .list-item__col,
.light-theme .user-row--odd .actions {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-row--even .list-item__col,
.light-theme .user-row--even .actions {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-caret {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-caret {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-user {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-user {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-role {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-role {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-onoff {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-onoff {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-conditions {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-conditions {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-delivery {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-delivery {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-expansion.user-row--odd .user-expansion__col-options {
  background-color: var(--zebra-odd) !important;
}
.light-theme .user-expansion.user-row--even .user-expansion__col-options {
  background-color: var(--zebra-even) !important;
}
.light-theme .user-row--even .delivery-tag:not(.delivery-tag--none) {
  background-color: #d1d1d1;
}

.dark-theme {
  --zebra-odd: rgb(10%, 10%, 10%);
  --zebra-even: rgb(15%, 15%, 15%);
}
.dark-theme .user-row--odd .list-item__col,
.dark-theme .user-row--odd .actions {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-row--even .list-item__col,
.dark-theme .user-row--even .actions {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-caret {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-caret {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-user {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-user {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-role {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-role {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-onoff {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-onoff {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-conditions {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-conditions {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-delivery {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-delivery {
  background-color: var(--zebra-even) !important;
}
.dark-theme .user-expansion.user-row--odd .user-expansion__col-options {
  background-color: var(--zebra-odd) !important;
}
.dark-theme .user-expansion.user-row--even .user-expansion__col-options {
  background-color: var(--zebra-even) !important;
}

.add-customization-modal {
  padding: 1rem;
}
.add-customization-modal__field {
  margin-bottom: 1rem;
}
.add-customization-modal__field label {
  display: block;
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}
.add-customization-modal__section-title {
  font-weight: 600;
  margin-bottom: 0.75rem;
  margin-top: 1rem;
}
.add-customization-modal__actions {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid rgb(90%, 90%, 90%);
}
.add-customization-modal__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 5rem 0;
  font-size: 0.85rem;
  color: #666666;
}

.matches-role-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin: 0.5rem 0;
  padding: 0;
  list-style: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */